import { create } from 'zustand'
import type {UserInfo} from "@/types";
import AuthService from "@/services/auth.ts";

// 定义状态类型
interface GlobalState {
    user: UserInfo | null;
    theme: 'light' | 'dark';
    notifications: number;
    token: string | null;
    // Actions
    setUser: (user: GlobalState['user']) => void;
    setTheme: (theme: GlobalState['theme']) => void;
    addNotification: () => void;
    clearNotifications: () => void;
}

// 创建全局store
export const useGlobalStore = create<GlobalState>((set) => ({
    // 初始状态
    user: AuthService.getUserInfo(),
    token: AuthService.getAccessToken(),
    theme: 'light',
    notifications: 0,



    // 更新方法
    setUser: (user) => set({ user }),
    setTheme: (theme) => set({ theme }),
    addNotification: () => set((state) => ({ notifications: state.notifications + 1 })),
    clearNotifications: () => set({ notifications: 0 }),
}));
